import { DisclosureCallbacks, useDisclosure } from "./use-disclosure";
import { useDebounce } from "./use-debounce";
import { useMemo } from "react";

export const useDisclosureDebounce = (
  defaultValue?: boolean,
  callbacks?: DisclosureCallbacks,
) => {
  const debounce = useDebounce();
  const [opened, _actions] = useDisclosure(defaultValue, {
    ...callbacks,
    onChange: (v) => {
      debounce.cancel();
      if (callbacks?.onChange) {
        callbacks.onChange(v);
      }
    },
  });
  const actions = useMemo(
    () => ({
      ..._actions,
      debounce: Object.assign(debounce, {
        set: (time: number, a: React.SetStateAction<boolean>) =>
          debounce(
            time,
            () => _actions.set(a),
            typeof a === "boolean" ? a : undefined,
          ),
        toggle: (time: number) => debounce(time, () => _actions.toggle()),
        open: (time: number) => debounce(time, () => _actions.open(), true),
        close: (time: number) => debounce(time, () => _actions.close(), false),
      }),
    }),
    [],
  );
  return [opened, actions] as const;
};
